<template>
  <DBox
    :id="'cmp-catalog-products-product_info'"
    :addButton="false"
  >
    <TextField2
      :disabled="selectedProductDetails.disabled"
      :id="'headline'"
      :placeholder="$t('type') + $t('headline_title')"
      :label="$t('headline_title')"
      :value="selectedProductDetails.product.headline"
      @blur="onTextFieldValueChange"
      bb="0px"
    />
    <!-- <TextField2
      :disabled="selectedProductDetails.disabled"
      :id="'product_info_english'"
      :placeholder="`${$t('type_in')} ${$t(
        'product_infos_english'
      )}`"
      :label="`${$t('add')} ${$t('product_infos_english')}`"
      :value="
        selectedProductDetails.product.product_info_english
      "
      @blur="onTextFieldValueChange"
      textarea
    />
    <TextField2
      :disabled="selectedProductDetails.disabled"
      :id="'product_info_second'"
      :placeholder="`${$t('type_in')} ${$t(
        'product_infos_second'
      )}`"
      :label="`${$t('add')} ${$t('product_infos_second')}`"
      :value="
        selectedProductDetails.product.product_info_second
      "
      @blur="onTextFieldValueChange"
      bb="0px"
    /> -->
  </DBox>
</template>

<script>
export default {
  props: {
    selectedProductDetails: {
      required: true,
    },
  },
  methods: {
    onTextFieldValueChange: function (event) {
      const { name, value } = event;
      this.$emit("changed", { name, value });
    },
    onDropdownChange: function (name, value) {
      this.$emit("changed", { name, value: value.value });
    },
  },
};
</script>

<style lang="scss">
.cmp-catalog-products-product_info {
  .fc2 {
    --fc2-lw: 180px !important;
  }
}
</style>
